module.exports = __webpack_public_path__ + "static/media/cook_logo.1cbcab4e.svg";